import { SisType } from '../schemas';

/**
 * お気に入りに保存された SIS タイプ絞り込みから、復元するコードを決める。
 *
 * マスタに無いコードは除外する（絞り込みは効くのにヘッダーに出ず全件非表示に見えるのを防ぐ）。
 *
 * `sisTypeOptions` が undefined のときはマスタ未取得として保存値をそのまま返す。
 * 空配列は取得済みだが 0 件として保存値を復元しない。
 */
export const resolveFavoriteFilteredSisTypeCodes = (
  savedSisTypeCodes: string[] | undefined,
  sisTypeOptions: SisType[] | undefined
): string[] => {
  if (savedSisTypeCodes == null || savedSisTypeCodes.length === 0) {
    return [];
  }

  if (sisTypeOptions === undefined) {
    return savedSisTypeCodes;
  }

  const availableSisTypeCodes = new Set(
    sisTypeOptions.map((sisType) => sisType.code)
  );
  return savedSisTypeCodes.filter((code) => availableSisTypeCodes.has(code));
};
